import { render } from "./UsersDataTable.vue?vue&type=template&id=171081b6"
import script from "./UsersDataTable.vue?vue&type=script&lang=js"
export * from "./UsersDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__